import axios from "../../service";
import alert from "@/_helpers/alert";
import moment from "moment";
import fn from "@/helpers/utility";
export const state = {
  keyAuth: {
    key: "pickup_point_flag",
    keyAdvance: "advanced_pickup_point_flag"
  }
};

export const mutations = {};

export const getters = {
  PermissionFlag(state) {
    return fn.PermissionFlag(state.keyAuth.keyAdvance);
  }
};

export const actions = {};
